const initialValues = {
  email: '',
  name: '',
  alerting: false,
  advertising: false,
  personalization: false,
  message: '',
};

function useForm({ initialValues: _initialValues, isValid }) {
  const [values, setValues] = useState({ ...initialValues, ..._initialValues });

  const onChange = (fieldName, value) => {
    setValues({
      ...values,
      [fieldName]: value,
    });
  };

  const valid = isValid(values);
  return { values, onChange, valid };
}

export default useForm;
